import axios from 'axios'

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URI,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'x-auth-token': window.localStorage.getItem('x-auth-token'),
    'Authorization': 'Basic ' + process.env.VUE_APP_BASIC_AUTH
  },
  timeout: 50000
})

export default {
  updateToken () {
    apiClient.defaults.headers['x-auth-token'] = `${
      window.localStorage.getItem('x-auth-token')
    }`
  },
  addDevice (data) {
    return apiClient.post('/addDevice', data)
  },
  register (data) {
    return apiClient.post('/metadata/profile', data)
  },
  addHealthData (data) {
    return apiClient.post('/addHealthData', data)
  },
  saveSurvey (surveyData) {
    return apiClient.post('/researchData', surveyData)
  },
  getLocationInfo () {
    return axios.get('https://ipapi.co/json/')
  },
  getCOVID19VaccineStats () {
    return apiClient.get('/COVID19Vaccine/stats')
  }
}
